import { CategoryModel } from "@app/catalog";

export class CategoryAddedMessage {
    public category: CategoryModel;
    
    constructor(category: CategoryModel)
    {
        this.category = category;
    }
}